import Booking from '@/views/Booking.vue'
import ETicket from '@/views/ETicket.vue'
import Home from '@/views/Home.vue'
import Index from '@/views/Index.vue'
import Maps from '@/views/Map.vue'
import Profil from '@/views/Profil.vue'
import Search from '@/views/Search.vue'
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
	{
		path: '/easyq/',
		name: 'Index',
		component: Index,
	},
	{
		path: '/easyq/:lang',
		// path: '/easyq',
		name: 'Home',
		component: Home,
		props: true,
	},
	{
		path: '/easyq/:lang/search/',
		name: 'Search',
		component: Search,
		props: true,
	},
	{
		path: '/easyq/:lang/booking/:id',
		name: 'Booking',
		component: Booking,
		props: true,
	},
	{
		path: '/easyq/:lang/e-ticket/:id',
		name: 'ETicket',
		component: ETicket,
		props: true,
	},
	{
		path: '/easyq/:lang/maps',
		name: 'Maps',
		component: Maps,
		props: true,
	},
	{
		path: '/easyq/:lang/profil',
		name: 'Profil',
		component: Profil,
		props: true,
	},
	// {
	//   path: '*',
	//   name: 'NotFound',
	//   component: NotFound
	// },
]

const router = new VueRouter({
	// base: process.env.NODE_ENV === 'production' ? '/control/' : '/control/',
	routes,
	mode: 'history',
})

export default router
